module.exports = __webpack_public_path__ + "assets/img/28_424.cf359e6f.jpg";